import { render, staticRenderFns } from "./CustomerSetting.vue?vue&type=template&id=dee1d6be&scoped=true&"
import script from "./CustomerSetting.vue?vue&type=script&lang=js&"
export * from "./CustomerSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee1d6be",
  null
  
)

export default component.exports